'use client';

import React from 'react';
import { Button } from '@ui';
import { SectionHeader } from '@layout';
import { portfolioPublicPath } from '@lib/portfolioBreadcrumbs';
import { sectionSlug, type PortfolioSection } from '@lib/portfolioSections';
import { t } from '@utils/translate';
import { renderTranslation } from '@utils/renderTranslation';

export interface PortfolioNavProps {
  portfolioSections: PortfolioSection[];
  locale: 'en' | 'es';
  headingType: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  headingClass?: string;
}

const PortfolioNav: React.FC<PortfolioNavProps> = ({
  portfolioSections,
  locale,
  headingType,
  headingClass,
}) => {
  if (portfolioSections.length === 0) return null;

  return (
    <nav
      className='portfolio-section-nav'
      aria-label={String(
        renderTranslation(t('section_links_nav_label', 'portfolio', locale)) || 'Portfolio sections'
      )}
    >
      <SectionHeader
        title={String(
          renderTranslation(t('section_links_title', 'portfolio', locale)) ||
            'Browse portfolio sections'
        )}
        description=''
        as={headingType}
        headingClassName={headingClass}
      />
      <ul className='portfolio-section-nav-list'>
        {portfolioSections.map((section, idx) => {
          const label =
            String(renderTranslation(section?.title)) || section?.title || `Section ${idx + 1}`;
          const slug = sectionSlug(section);
          const href = portfolioPublicPath(locale, slug);
          return (
            <li key={`${slug}-${idx}`}>
              <Button as='a' href={href} label={label} className='btn-sm' />
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default PortfolioNav;
